import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Hi 👋
    </Text>
    <p>{`I'm Adrian - I’m a software developer and site reliability engineer. My drive is to make technology easy to use and simple to develop.`}</p>
    <p>{`I want to live in a world filled with innovative technology, programmable weather for endless sunshine and MacBooks bundled with a fountain of third-wave coffee.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      